import {
  UsersAuthzUserPermissionDto,
  useUsersAuthzGetManagedPermissionsPermissionsOfUser,
  useUsersAuthzGetPermissionsCatalog,
  useUsersAuthzResetUserPermissionsManagedPermissions,
} from '@mi-front/api-v2';
import { User } from '@mi-front/core';
import { useQueryClient } from '@tanstack/react-query';
import { ActionPermissionsView, PermissionItemComponentProps } from './ActionPermissionsView';
import { UserPermissionItem } from './UserPermissionItem';

interface Props {
  readonly user: User;
}

/**
 * Admin view to list and reset managed action permissions for a user.
 */
export function UserActionPermissionsView(p: Props) {
  const queryClient = useQueryClient();
  const { user } = p;

  const permissionsCatalogQuery = useUsersAuthzGetPermissionsCatalog();
  const userPermissionsQuery = useUsersAuthzGetManagedPermissionsPermissionsOfUser(user.id);

  const UserPermissionItemWrapper = (
    props: PermissionItemComponentProps<UsersAuthzUserPermissionDto>,
  ) => <UserPermissionItem {...props} userId={user.id} groupId={user.groupId} />;

  const resetMutation = useUsersAuthzResetUserPermissionsManagedPermissions();

  return (
    <ActionPermissionsView
      catalog={permissionsCatalogQuery.data}
      permissions={userPermissionsQuery.data?.permissions}
      PermissionItemComponent={UserPermissionItemWrapper}
      isLoading={permissionsCatalogQuery.isLoading || userPermissionsQuery.isLoading}
      error={permissionsCatalogQuery.error || userPermissionsQuery.error}
      onReset={async () => {
        await resetMutation.mutateAsync({
          userId: user.id,
        });

        queryClient.invalidateQueries({
          queryKey: userPermissionsQuery.queryKey,
        });
      }}
    />
  );
}
